import React, { useState } from 'react';

import { useDispatch } from 'react-redux';

import { impersonateUser } from '../../../redux/slices/accountInfoSlice/actions';

import styles from './Impersonation.module.scss';

function Impersonation() {
  const dispatch = useDispatch();
  const [mobile, setMobile] = useState('');
  const [error, setError] = useState('');
  const [response, setResponse] = useState('');

  const impersonateUserFunc = async () => {
    if (mobile?.length === 0) {
      setError('Please Enter Mobile Number');
    } else if (mobile?.length === 10) {
      const res = await dispatch(impersonateUser(mobile)).unwrap();
      if (res?.didImpersonate) {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
      setResponse(res?.message);
    } else if (mobile?.length < 10) {
      setError('Please enter valid mobile number');
    }
  };
  return (
    <div className={styles.impersonationWrapper}>
      <div className={styles.formLabel}>Mobile Number</div>
      <div className={styles.formWrapper}>
        <div>
          <input
            type="tel"
            maxLength={10}
            id="mobile"
            onChange={(e) => {
              const numericValue = e.target.value.replace(/[^0-9]/g, ''); // Allow only numeric characters
              setError(null);
              setMobile(numericValue);
            }}
            value={mobile}
            className={styles.formInput}
            placeholder="Enter your Mobile"
          />
          {error && <div className={styles?.errorMsg}>{error}</div>}
          {response && <div className={styles?.msg}>{response}</div>}
        </div>
        <div className={styles.btn} onClick={impersonateUserFunc}>
          Impersonate Profile
        </div>
      </div>
    </div>
  );
}

export default Impersonation;
